// removed by extract-text-webpack-plugin
module.exports = {"loading":"_1qCTE-VVrEy4XeXm4bBRbK","rotating":"_2h9JkrTVxy42Syo-sFnD8D"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/loader/loader.scss
// module id = 436
// module chunks = 0